import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  getApiBaseUrl,
  EDIT_USER,
  ADD_ACTIVITY,
  LOGIN,
  GET_ROLES,
} from "../../Config/Config";
import Swal from "sweetalert2";
import { Spin } from "antd";

const EditUser = ({ userData }) => {
  const [formState, setFormState] = useState({
    UserID: "",
    Name: "",
    Role: "",
  });
  const [loading, setLoading] = useState(false);
  const [editAskPassword, setEditAskPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [error, setError] = useState("");
  const [roles, setRoles] = useState([]); // New state for roles
  const user = JSON.parse(sessionStorage.getItem("user"));

  // Fetch roles on component mount
  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const res = await fetch(`${getApiBaseUrl()}${GET_ROLES}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        const result = await res.json();
        if (result.Status && result.ResultData) {
          setRoles(result.ResultData);
        }
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    fetchRoles();
  }, []);

  useEffect(() => {
    if (userData) {
      setFormState({
        UserName: userData?.Username || "",
        Name: userData?.Name || "",
        Role: userData?.Role || "",
      });
    }
  }, [userData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async () => {
    const payload = {
      UserID: userData?.UserID,
      Name: formState?.Name,
      Role: Number(formState?.Role),
    };
    setLoading(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}${EDIT_USER}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Edit user result:", result);

      if (result.Status) {
        const activityPayload = {
          ActivityType: 1,
          PerformedBy: user?.UserID,
          PerformedOn: new Date().toISOString().slice(0, 19).replace("T", " "),
          Notes: `User details Updation of ${formState?.UserName}`,
          Location: "Users",
          IsSucces: 1,
        };

        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(activityPayload),
        });
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: "User updated successfully!",
        }).then(() => {
          window.location.reload();
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: "Something went wrong.",
        });
      }
    } catch (error) {
      console.error("Error updating user:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to connect to the server.",
      });
    } finally {
      setLoading(false);
    }
  };

  const clearUserData = () => {
    setEditAskPassword(false);
    setPassword("");
    setError("");
  };

  useEffect(() => {
    const offcanvas = document.getElementById("offcanvasEditUser");
    if (offcanvas) {
      const handleClose = () => {
        clearUserData();
      };
      offcanvas.addEventListener("hidden.bs.offcanvas", handleClose);
      return () => {
        offcanvas.removeEventListener("hidden.bs.offcanvas", handleClose);
      };
    }
  }, []);

  const handleSaveClick = (e) => {
    e.preventDefault();
    setEditAskPassword(true);
  };

  const handleAuth = async () => {
    setAuthLoading(true);
    setError("");
    const user = JSON.parse(sessionStorage.getItem("user"));

    try {
      const payload = {
        username: user.UserName,
        password,
      };

      const res = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.status) {
        setEditAskPassword(false);
        setPassword("");
        await handleSubmit();
      } else {
        setError("Invalid credentials");
      }
    } catch (err) {
      setError("Invalid Password. Please try again.");
    } finally {
      setAuthLoading(false);
    }
  };

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasEditUser {
            width: 90% !important;
          }
        }
        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasEditUser {
            width: 55% !important;
          }
        }
        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasEditUser {
            width: 35% !important;
          }
        }
        @media (min-width: 1441px)  {
          #offcanvasEditUser {
            width: 20% !important;
          }
        }
      `}
      </style>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      {authLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)", // subtle tint
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasEditUser"
        aria-labelledby="offcanvasEditUserLabel"
      >
        <form>
          <div className="offcanvas-header d-flex justify-content-between align-items-center w-100">
            <h5 id="offcanvasEditUserLabel">Edit User</h5>
            <div className="d-flex align-items-center ms-auto">
              <button
                type="submit"
                className={`btn btn-sm btn-outline-success me-2 ${
                  editAskPassword ? "d-none" : ""
                }`}
                title="Save"
                onClick={handleSaveClick}
              >
                <i className="fa fa-check fs-4"></i>
              </button>
              <button
                type="button"
                className="btn-close text-reset"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
          </div>
          <hr className="m-0" />
          <div className="offcanvas-body">
            <div className="row">
              <div className="col-6 mb-3">
                <label className="form-label">User ID</label>
                <input
                  type="text"
                  name="UserID"
                  className="form-control"
                  placeholder="Enter User ID"
                  value={formState?.UserName}
                  onChange={handleChange}
                  required
                  disabled
                />
              </div>
              <div className="col-6 mb-3">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Name"
                  name="Name"
                  value={formState?.Name}
                  onChange={handleChange}
                  required
                  disabled={editAskPassword}
                />
              </div>
              <div className="col-6 mb-3">
                <label className="form-label">Role</label>
                <select
                  className="form-select"
                  name="Role"
                  value={formState?.Role}
                  onChange={handleChange}
                  disabled={editAskPassword}
                >
                  <option value="">Select Role</option>
                  {roles.map((role) => (
                    <option key={role.id} value={role.id}>
                      {role.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            {editAskPassword && (
              <div className="mt-2">
                <div className="mb-3 w-lg-75 m-auto">
                  <label className="form-label">
                    Confirm Password <span className="text-danger"> *</span>
                  </label>
                  <div className="pass-group">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      className="pass-input form-control"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onCopy={(e) => e.preventDefault()}
                      onPaste={(e) => e.preventDefault()}
                      onCut={(e) => e.preventDefault()}
                      placeholder="Enter Password"
                    />
                    <span
                      className={`ti toggle-password ${
                        showPassword ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => setShowPassword(!showPassword)}
                    ></span>
                  </div>
                </div>
                {error && <div className="text-danger small mb-2">{error}</div>}
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={handleAuth}
                  disabled={authLoading || !password}
                >
                  {authLoading ? "Verifying..." : "Confirm"}
                </button>
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => {
                    setEditAskPassword(false);
                    setPassword("");
                    setError("");
                  }}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

EditUser.propTypes = {
  userData: PropTypes.shape({
    Name: PropTypes.string,
    Email: PropTypes.string,
    Phone: PropTypes.string,
    Username: PropTypes.string,
    UserID: PropTypes.number,
    Role: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    HasMobile: PropTypes.bool,
  }).isRequired,
};

export default EditUser;
